// extracted by mini-css-extract-plugin
export default {"iconMenu":"Home_iconMenu__-tvPU","icon":"Home_icon__Bd4pt"};